import { xcss } from '@atlaskit/primitives';

export const totalEstimateStyle = xcss({
  borderRadius: 'border.radius.200',
  border: '1px solid',
  borderColor: 'color.border',
});
